document.addEventListener("latte:init", init);
function init () {
    var exist = false;
    var players = [];
    //for single video
    $('.bright-cove').on('click', function (e) {
        if (!exist) {
            $.getScript("//players.brightcove.net/1107601868001/r1lYjyDwux_default/index.min.js")
                .done(function (script) {
                    exist = true;
                    callback(e);
                });
        } else {
            callback(e);
        }
    });

    //after load check if .bright-cove-playlist exist if so then inject the playlist video js.
    if ($(document).find('.bright-cove-playlist').length === 1) {
        $.getScript("//players.brightcove.net/1107601868001/BJsSYXDB_default/index.min.js");
    }

    function callback (e) {
        var v = Object.keys(videojs.players);
        for (var x = 0; x < v.length; x++) {
            var setPlayer = v[x];
            /* jshint ignore:start */
            videojs(setPlayer).ready(function () {
                player = this;
                player.on('play', onPlay);
                players.push(player);
            });
            /* jshint ignore:end */
        }
    }

    function onPlay (e) {
        var id = e.target.id;
        for (var i = 0; i < players.length; i++) {
            if (players[i].id() != id) {
                videojs(players[i].id()).pause();
            }
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./public/js/brightCovePlayer.js
// module id = 68
// module chunks = 0